export default __webpack_public_path__ + "static/aca-logo-c00cc904edbc3052ecff9075e6574522.png";